import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminRoute from "./components/AdminRoute";
import AdminLayout from "./layouts/AdminLayout";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import EditProduct from "./pages/product/EditProduct";
import NewProduct from "./pages/product/NewProduct";
import ProductList from "./pages/product/ProductList";
import SingleProduct from "./pages/product/SingleProduct";
import NewVendor from "./pages/vendor/NewVendor";
import SingleVendor from "./pages/vendor/SingleVendor";
import VendorList from "./pages/vendor/VendorList";
import UserList from "./pages/user/UserList";
import SingleUser from "./pages/user/SingleUser";
import NewUser from "./pages/user/NewUser";
import EditUser from "./pages/user/EditUser";
import Register from "./pages/signup/Register";
import CreateStore from "./pages/signup/CreateStore";
import Profile from "./pages/profile/Profile";
import AllProducts from "./pages/product/AllProducts";
import CategoryList from "./pages/categories/CategoryList";
import NewCategory from "./pages/categories/NewCategory";

function App() {
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/">
          <Route
            index
            element={
              <AdminRoute>
                <AdminLayout>
                  <Home />
                </AdminLayout>
              </AdminRoute>
            }
          />
          <Route index path="login" element={<Login />} />
          <Route index path="register" element={<Register />} />
          <Route
            index
            path="create-store"
            element={
              <AdminRoute>
                <AdminLayout>
                  <CreateStore />
                </AdminLayout>
              </AdminRoute>
            }
          />
          <Route path="users">
            <Route
              index
              element={
                <AdminRoute>
                  <AdminLayout>
                    <UserList />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path=":userId"
              element={
                <AdminLayout>
                  <SingleUser />
                </AdminLayout>
              }
            />
            <Route
              index
              path=":id/edit"
              element={
                <AdminLayout>
                  <EditUser />
                </AdminLayout>
              }
            />
            <Route
              index
              path="new"
              element={
                <AdminLayout>
                  <NewUser />
                </AdminLayout>
              }
            />
          </Route>
          <Route path="products">
            <Route
              index
              element={
                <AdminRoute>
                  <AdminLayout>
                    <ProductList />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path=":productId"
              element={
                <AdminLayout>
                  <SingleProduct />
                </AdminLayout>
              }
            />
            <Route
              index
              path="new"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <NewProduct />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path=":id/edit"
              element={
                <AdminLayout>
                  <EditProduct />
                </AdminLayout>
              }
            />
          </Route>

          <Route path="all-products">
            <Route
              index
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AllProducts />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path=":productId"
              element={
                <AdminLayout>
                  <SingleProduct />
                </AdminLayout>
              }
            />
            <Route
              index
              path="new"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <NewProduct />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path=":id/edit"
              element={
                <AdminLayout>
                  <EditProduct />
                </AdminLayout>
              }
            />
          </Route>
          <Route path="all-stores">
            <Route
              index
              element={
                <AdminRoute>
                  <AdminLayout>
                    <VendorList />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path=":/storeId"
              element={
                <AdminLayout>
                  <SingleVendor />
                </AdminLayout>
              }
            />
            <Route
              index
              path="new"
              element={
                <AdminLayout>
                  <NewVendor />
                </AdminLayout>
              }
            />
            <Route
              index
              path="edit:/id"
              element={
                <AdminLayout>
                  <NewVendor />
                </AdminLayout>
              }
            />
          </Route>

          <Route path="category">
            <Route
              index
              element={
                <AdminRoute>
                  <AdminLayout>
                    <CategoryList />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path="new"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <NewCategory />
                  </AdminLayout>
                </AdminRoute>
              }
            />
            <Route
              index
              path="edit/:id"
              element={
                <AdminRoute>
                  <AdminLayout>
                    <NewCategory />
                  </AdminLayout>
                </AdminRoute>
              }
            />
          </Route>
          <Route
            index
            path="/profile"
            element={
              <AdminLayout>
                <Profile />
              </AdminLayout>
            }
          />
        </Route>
      </Routes>
    </>
  );
}

export default App;
